module.exports = __webpack_public_path__ + "static/pill-group-l-6f31cb8ecc85c35bf4041ea2a8b0999d.svg";